import {createSlice} from "@reduxjs/toolkit";
import {
  getInvoiceDetail,
  getInvoices,
  getRefundByInvoiceId,
  updateInvoiceStatus
} from './action'

const initialState = {
  state: {
    invoices: [],
    refundsHistory: [],
    paging: null,
    detail: null
  },
  loading: true,
  error: ''
} as BaseState<InvoiceState>

const slice = createSlice({
  name: 'invoiceSlice',
  initialState,
  reducers: {
    resetInvoice: () => ({ ...initialState }),
    setInvoiceDetail: (state, action) => ({
      ...state,
      state: {
        ...state.state,
        detail: action.payload
      }
    })
  },
  extraReducers: (builder) => {
    // summary
    builder.addCase(getInvoices.pending, (state) => ({
        ...state,
        loading: true
      }))
    builder.addCase(getInvoices.fulfilled, (state, action) => {
        const {items, paging} = action.payload
        return {
          state: {
            ...state.state,
            paging,
            invoices: items
          },
          error: null,
          loading: false
        }
      })
    builder.addCase(getInvoices.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed to get invoices'
      }))

    // detail
    builder.addCase(getInvoiceDetail.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(getInvoiceDetail.fulfilled, (state, action) => ({
      state: {
        ...state.state,
        detail: action.payload
      },
      error: null,
      loading: false
    }))
    builder.addCase(getInvoiceDetail.rejected, (state) => ({
      ...state,
      loading: true,
      error: 'Failed to get invoice detail'
    }))

    // update status
    builder.addCase(updateInvoiceStatus.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(updateInvoiceStatus.fulfilled, (state) => ({
      ...state,
      error: null,
      loading: false
    }))
    builder.addCase(updateInvoiceStatus.rejected, (state) => ({
      ...state,
      loading: true,
      error: 'Failed to update invoice status'
    }))
    
    // refunds history
    builder.addCase(getRefundByInvoiceId.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(getRefundByInvoiceId.fulfilled, (state, action) => {
      const {items} = action.payload
      return {
        state: {
          ...state.state,
          refundsHistory: items
        },
        error: null,
        loading: false
      }
    })
    builder.addCase(getRefundByInvoiceId.rejected, (state) => ({
      ...state,
      loading: true,
      error: 'Failed to get refund history'
    }))
  }
})

export const invoiceActions = slice.actions
export default slice
